import { runtimeConfig } from './runtimeConfig';
// Environment variables with runtime configuration support
// These values can be overridden at runtime via runtime-config.js
export const WS_URL = runtimeConfig.getWebSocketUrl();
export const ALPHALEND_WS_URL = runtimeConfig.getAlphalendWebSocketUrl();
export const API_BASE_URL = runtimeConfig.getApiBaseUrl();
export const APR_URL = runtimeConfig.getAprUrl();
// Feature flags
export const ENABLE_WEBSOCKET = runtimeConfig.isWebSocketEnabled();
export const ENABLE_DEBUG_LOGS = runtimeConfig.isDebugLogsEnabled();
// Network configuration
export const NETWORKS = {
    mainnet: {
        url: runtimeConfig.getRpcUrl('mainnet') || 'https://fullnode.mainnet.sui.io/',
    },
    testnet: {
        url: runtimeConfig.getRpcUrl('testnet') || 'https://fullnode.testnet.sui.io/',
    },
    devnet: {
        url: runtimeConfig.getRpcUrl('devnet') || 'https://fullnode.devnet.sui.io/',
    },
};
